import { graphql } from "@apollo/client/react/hoc";
import DELETE_ITEM from "./delete-item.query";

export default graphql(DELETE_ITEM, { name: "deleteItem" });
